import { render } from "./HelperText.vue?vue&type=template&id=204a3256&scoped=true"
const script = {}

import "./HelperText.vue?vue&type=style&index=0&id=204a3256&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-204a3256"

export default script